import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Layout from '../components/Layout/Layout';

import Dashboard from '../pages/SuperAdmin/Dashboard/Dashboard';
import Analytics from '../pages/SuperAdmin/Analytics/Analytics';

import Websites from '../pages/SuperAdmin/Websites/Websites';
import CreateWebsite from '../pages/SuperAdmin/Websites/CreateWebsite';
import EditWebsite from '../pages/SuperAdmin/Websites/EditWebsite';

import Admins from '../pages/SuperAdmin/Admins/Admins';
import CreateAdmin from '../pages/SuperAdmin/Admins/CreateAdmin';
import EditAdmin from '../pages/SuperAdmin/Admins/EditAdmin';

const SuperAdminRoutes = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/websites" element={<Websites />} />
        <Route path="/websites/create" element={<CreateWebsite />} />
        <Route path="/websites/edit/:websiteId" element={<EditWebsite />} /> {/* Add the edit route */}
        <Route path="/admins" element={<Admins />} />
        <Route path="/admins/create" element={<CreateAdmin />} />
        <Route path="/admins/edit/:adminId" element={<EditAdmin />} />
        <Route path="/analytics" element={<Analytics />} />
      </Routes>
    </Layout>
  );
};

export default SuperAdminRoutes;